export const SUGGESTION_ROOT = 'suggestion'

export const getSuggestionKey = id => `suggestion_${id}`

export const TRANSIENT_SUGGESTION_KEY = 'suggestion_transient'

export const SUGGESTION_TYPES = {
  insert: 'insert',
  remove: 'remove'
}
